import { Button, Typography } from "@mui/material";
import Modal from "../src/components/modal/Modal";
import styled from "@emotion/styled";

function App() {
  const params = new URLSearchParams(window.location.search);
  const showDiv = params.get("tools") !== "true";
  return (
    <div className="App">
      {showDiv && (
        <div
          style={{
            width: "100%",
            height: "70px",
            backgroundColor: "#424242",
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
            fontFamily: "fonts/Oxygen-Light",
            marginBottom: "20px",
          }}
        >
          <Typography
            sx={{
              width: "100%",
              color: "white",
              fontFamily: "fonts/Oxygen-Light",
              textAlign: "center",
            }}
            variant="h4"
          >
            Teldio Trufleet Adder
          </Typography>
          <img
            src="/assets/logo.png"
            alt="teldio logo"
            style={{
              height: "35px",
              marginRight: "15px",
              cursor: "pointer",

              position: "absolute",
            }}
            onClick={() => {
              window.location.href = "/a/web/#/d/";
            }}
          />
        </div>
      )}
      <Modal />
    </div>
  );
}

export default App;
